import { PlanFilesOutput } from '@coverright/data-access/types/medicare';
import { PlanYear } from '@coverright/data-access/types/medicare';
import { environment } from '@coverright/shared/config';

export function planFiles(
  files?: PlanFilesOutput | null,
  year?: PlanYear | null
) {
  if (files) {
    const prefix = environment.filesUrl + '/';
    const result: PlanFile[] = [];

    for (const key in map) {
      const value = files[key as keyof PlanFilesOutput];
      if (value) {
        result.push({
          label: map[key],
          url: /^https?:\/\//.test(value) ? value : prefix + value,
        });
      }
    }

    return result;
  }
  return [];
}

interface PlanFile {
  url: string;
  label: string;
}

const map: { [key: string]: string } = {
  summaryOfBenefitsUrl: 'Summary of Benefits',
  evidenceOfCoverageDocUrl: 'Evidence of Coverage',
  starRatingDescDocUrl: 'CMS star ratings information',
  nonDiscriminationNoticeDocUrl:
    'Language Assistance / Non-discrimination Notice',
};
